import { render, staticRenderFns } from "./paragraph.vue?vue&type=template&id=0ce08a0c&"
import script from "./paragraph.vue?vue&type=script&lang=js&"
export * from "./paragraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports